/* Exploro Drug Testing Hub — progressive enhancement only.
   Without this file: guide links still work, FAQs are native <details>,
   search degrades to the category grid below it. */
(function () {
  'use strict';

  var SYNONYMS = {
    weed: 'thc marijuana cannabis', pot: 'thc marijuana', marijuana: 'thc cannabis',
    cannabis: 'thc marijuana', edible: 'thc marijuana', edibles: 'thc marijuana',
    swab: 'oral fluid saliva', mouth: 'oral fluid saliva', saliva: 'oral fluid',
    cdl: 'fmcsa dot driver', trucker: 'fmcsa dot driver', driver: 'fmcsa dot',
    fail: 'positive result', failed: 'positive result', failing: 'positive result',
    pass: 'negative result', passed: 'negative result',
    pee: 'urine', urinate: 'urine', ngml: 'cutoff', level: 'cutoff', limit: 'cutoff',
    line: 'faint line result', lines: 'faint line result',
    job: 'pre-employment employer workplace', hired: 'pre-employment', interview: 'pre-employment',
    mro: 'medical review officer', sap: 'substance abuse professional',
    rtd: 'return to duty', boss: 'employer', work: 'workplace employer'
  };

  function push(event, params) {
    window.dataLayer = window.dataLayer || [];
    var payload = { event: event };
    for (var k in params) { if (Object.prototype.hasOwnProperty.call(params, k)) payload[k] = params[k]; }
    window.dataLayer.push(payload);
  }

  document.addEventListener('click', function (e) {
    var el = e.target && e.target.closest ? e.target.closest('[data-dh-event]') : null;
    if (!el) return;
    var params = {};
    for (var i = 0; i < el.attributes.length; i++) {
      var a = el.attributes[i];
      if (a.name.indexOf('data-dh-p-') === 0) params[a.name.slice(10).replace(/-/g, '_')] = a.value;
    }
    push(el.getAttribute('data-dh-event'), params);
  }, true);

  function slug(text, used) {
    var base = text.toLowerCase().replace(/[^a-z0-9\s-]/g, '').trim().replace(/\s+/g, '-').slice(0, 60) || 'section';
    var out = base, n = 2;
    while (used[out]) { out = base + '-' + n; n++; }
    used[out] = true;
    return out;
  }

  function buildToc() {
    var prose = document.querySelector('[data-dh-prose]');
    var targets = document.querySelectorAll('[data-dh-toc]');
    if (!prose || !targets.length) return;
    var heads = prose.querySelectorAll('h2');
    if (heads.length < 2) return;

    var used = {}, items = [];
    Array.prototype.forEach.call(heads, function (h) {
      if (!h.id) h.id = slug(h.textContent || '', used);
      items.push({ id: h.id, text: (h.textContent || '').trim(), el: h });
    });

    var guide = prose.getAttribute('data-dh-guide') || '';
    Array.prototype.forEach.call(targets, function (target) {
      var ol = document.createElement('ol');
      items.forEach(function (it) {
        var li = document.createElement('li');
        var a = document.createElement('a');
        a.href = '#' + it.id;
        a.textContent = it.text;
        a.setAttribute('data-dh-event', 'drug_hub_toc_click');
        a.setAttribute('data-dh-p-section', it.text);
        a.setAttribute('data-dh-p-guide', guide);
        li.appendChild(a);
        ol.appendChild(li);
      });
      target.appendChild(ol);
      target.hidden = false;
    });

    if (!('IntersectionObserver' in window)) return;
    var links = document.querySelectorAll('[data-dh-toc] a');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        Array.prototype.forEach.call(links, function (a) {
          a.setAttribute('aria-current', a.getAttribute('href') === '#' + entry.target.id ? 'true' : 'false');
        });
      });
    }, { rootMargin: '-96px 0px -70% 0px', threshold: 0 });
    items.forEach(function (it) { io.observe(it.el); });
  }

  function wireFaq() {
    var prose = document.querySelector('[data-dh-prose]');
    var guideHandle = prose ? prose.getAttribute('data-dh-guide') : '';
    Array.prototype.forEach.call(document.querySelectorAll('[data-dh-faq] details'), function (d) {
      d.addEventListener('toggle', function () {
        var s = d.querySelector('summary');
        if (s) s.setAttribute('aria-expanded', d.open ? 'true' : 'false');
        if (d.open) push('drug_hub_faq_open', { question: d.getAttribute('data-question') || '', guide: guideHandle });
      });
    });
  }

  function expand(q) {
    var words = q.toLowerCase().split(/[^a-z0-9]+/).filter(Boolean);
    var out = words.slice();
    words.forEach(function (w) { if (SYNONYMS[w]) out = out.concat(SYNONYMS[w].split(' ')); });
    return out;
  }

  function wireSearch() {
    var root = document.querySelector('[data-dh-search]');
    if (!root) return;
    var input = root.querySelector('input[type="search"]');
    var panel = root.querySelector('[data-dh-search-results]');
    var raw = document.getElementById('dh-search-index');
    if (!input || !panel || !raw) return;

    var index;
    try { index = JSON.parse(raw.textContent); } catch (e) { return; }
    if (!index || !index.length) return;

    var timer, lastQuery = '', activeIndex = -1;

    function score(item, terms) {
      var total = 0;
      for (var i = 0; i < terms.length; i++) {
        var t = terms[i];
        if (t.length < 2) continue;
        if (item.t.toLowerCase().indexOf(t) > -1) total += 3;
        else if (item.s.indexOf(t) > -1) total += 1;
      }
      return total;
    }

    function render(results, query) {
      activeIndex = -1;
      if (!query) { panel.hidden = true; panel.innerHTML = ''; return; }
      if (!results.length) {
        panel.innerHTML = '<p class="dh-search__empty">No guide matches that yet. Browse the categories below, or try a shorter phrase.</p>';
        panel.hidden = false;
        return;
      }
      var ul = document.createElement('ul');
      results.forEach(function (item) {
        var li = document.createElement('li');
        var a = document.createElement('a');
        a.href = item.u;
        var t = document.createElement('span');
        t.className = 'dh-search__rtitle';
        t.textContent = item.t;
        var m = document.createElement('span');
        m.className = 'dh-search__rmeta';
        m.textContent = item.c;
        a.appendChild(t);
        a.appendChild(m);
        a.addEventListener('click', function () {
          push('drug_hub_search_click', { query: query, destination_page: item.u });
        });
        li.appendChild(a);
        ul.appendChild(li);
      });
      panel.innerHTML = '';
      panel.appendChild(ul);
      panel.hidden = false;
    }

    function run() {
      var query = input.value.trim();
      if (query === lastQuery) return;
      lastQuery = query;
      if (query.length < 2) { render([], ''); return; }
      var terms = expand(query);
      var scored = [];
      for (var i = 0; i < index.length; i++) {
        var s = score(index[i], terms);
        if (s > 0) scored.push({ item: index[i], s: s });
      }
      scored.sort(function (a, b) { return b.s - a.s; });
      render(scored.slice(0, 8).map(function (r) { return r.item; }), query);
      push('drug_hub_search', { query: query, result_count: scored.length });
    }

    input.addEventListener('input', function () {
      clearTimeout(timer);
      timer = setTimeout(run, 220);
    });

    input.addEventListener('keydown', function (e) {
      var items = panel.querySelectorAll('li');
      if (e.key === 'Escape') { panel.hidden = true; input.blur(); return; }
      if (!items.length) return;
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        activeIndex += e.key === 'ArrowDown' ? 1 : -1;
        if (activeIndex < 0) activeIndex = items.length - 1;
        if (activeIndex >= items.length) activeIndex = 0;
        Array.prototype.forEach.call(items, function (li, i) {
          if (i === activeIndex) li.setAttribute('data-active', '');
          else li.removeAttribute('data-active');
        });
      } else if (e.key === 'Enter' && activeIndex > -1) {
        var link = items[activeIndex].querySelector('a');
        if (link) { e.preventDefault(); link.click(); }
      }
    });

    document.addEventListener('click', function (e) {
      if (!root.contains(e.target)) panel.hidden = true;
    });

    root.addEventListener('submit', function (e) { e.preventDefault(); run(); });
  }

  function wireStates() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-dh-states]'), function (sel) {
      sel.addEventListener('change', function () {
        var opt = sel.options[sel.selectedIndex];
        if (!opt || !opt.value) return;
        push('drug_hub_state_select', { state: opt.getAttribute('data-state') || opt.text });
        window.location.href = opt.value;
      });
    });
  }

  function init() {
    buildToc();
    wireFaq();
    wireSearch();
    wireStates();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();